const sjSharedLibrary = require('@sj/shared-library');

const errorLoggerService = new sjSharedLibrary.ErrorLoggerService('Homepage');


let demoRequestUrl = '';

function showFormMessage(event) {
    event.preventDefault();

    const form = document.querySelector('form.with-message');
    const message = document.querySelector('.form-success-message');
    const formData = getFormDataForPost(new FormData(this));

    errorLoggerService.logInfo(`demo.showFormMessage() called with form data: ${formData}`);

    fetch(demoRequestUrl, {
        body: formData,
        method: 'POST'
    });

    message.previousSibling.setAttribute('style', 'display:none');
    form.setAttribute('style', 'display:none');
    message.setAttribute('style', 'display:block');
}

document.addEventListener('DOMContentLoaded', function () {

    fetch('assets/demo-request.json')
        .then(response => response.json())
        .then(demoRequest => {
            demoRequestUrl = demoRequest.demoRequest.url;

            if (document.querySelector('form.with-message')) {
                document.querySelector('form.with-message').addEventListener('submit', showFormMessage);
            }
        });

    configureFormValidation();
});

function configureFormValidation() {
    document.querySelectorAll('input[required]')
        .forEach(input => {
            input.addEventListener('invalid', function (event) {
                document.activeElement.blur();

                const label = event.target.previousElementSibling?.textContent.replace('*', '').trim();
                console.log(label, event.target.validity)
                let validationIssue = '';
                if (event.target.validity.valueMissing) {
                    validationIssue = label ? `${label} is required.` : 'This field is required.';
                    event.target.setCustomValidity(validationIssue);
                } else if (event.target.validity.typeMismatch && event.target.type === 'email') {
                    validationIssue = 'Please enter a valid email address.';
                    event.target.setCustomValidity(validationIssue);
                } else {
                    validationIssue = `Invalid for unknown reason`;
                }

                errorLoggerService.logDebug(`demo.configureFormValidation() failed for ${label} with error: ${validationIssue}`);
            });

            input.addEventListener('change', function (event) {
                event.target.setCustomValidity('');
            });
        });
}

function getFormDataForPost(formData) {
    const dataToPost = {};

    for (let tuple of formData.entries())
    {
        dataToPost[tuple[0]] = tuple[1];
    }

    return JSON.stringify(dataToPost);
}
